import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
  SelectInput,
} from 'react-admin';

const audienceChoices = [
  { id: 'all', name: 'All Visitors (গেস্ট + লগইন উভয়কে দেখাবে)' },
  { id: 'login', name: 'Logged-in Users Only (শুধু লগইনের পর দেখাবে)' },
];

export const PromotionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ImageInput source="image" label="Image" accept="image/*" isRequired>
        <ImageField source="src" title="title" />
      </ImageInput>

      <SelectInput source="audience" label="Audience" choices={audienceChoices} defaultValue="all" />

      <BooleanInput source="is_active" label="Is active" defaultValue={true} />

      <NumberInput source="daily_display_limit" label="Daily display limit" defaultValue={1} />
    </SimpleForm>
  </Create>
);

// ---------- EDIT ----------
const formatImage = (value) => {
  if (!value) return value;
  if (typeof value === 'string') {
    return { src: value, title: value };
  }
  return value;
};

const parseImage = (value) => {
  if (!value) return null;
  if (value.rawFile) return value;
  return value.src;
};

export const PromotionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ImageInput
        source="image"
        label="Image"
        accept="image/*"
        format={formatImage}
        parse={parseImage}
      >
        <ImageField source="src" title="title" />
      </ImageInput>

      <SelectInput source="audience" label="Audience" choices={audienceChoices} />

      <BooleanInput source="is_active" label="Is active" />

      <NumberInput source="daily_display_limit" label="Daily display limit" />
    </SimpleForm>
  </Edit>
);